import React from "react";
import { ArrowRightOutlined } from "@ant-design/icons";

const CTAButton = ({ children, variant = "primary", onClick }) => (
  <button
    onClick={onClick}
    className={`px-8 py-3 rounded-full font-semibold transition duration-300 ${
      variant === "primary"
        ? "bg-blue-600 text-white hover:bg-blue-700"
        : "bg-white text-[#51dcb1] hover:bg-blue-50"
    }`}
  >
    {children}
    <ArrowRightOutlined className="ml-2" />
  </button>
);

const CTASection = () => {
  // Handler for restaurant demo button
  const handleRestaurantDemoClick = () => {
    window.open("https://restropos.snapposs.com/restaurant-signup", "_blank");
  };
  const handleRetailDemoClick = () => {
    window.open(
      "https://retailpos.snapposs.com/Authentication/signup",
      "_blank",
    );
  };

  return (
    <div className="py-20 bg-[#51dcb1] ">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-4xl font-bold text-black mb-4">
          Ready to Transform Your Business?
        </h2>
        <p className="text-xl text-black-100 mb-12">
          Contact us today to schedule a free demo and see how our POS solutions
          can help your business grow.
        </p>
        <div className="flex flex-col md:flex-row gap-4 justify-center">
          <CTAButton variant="secondary" onClick={handleRestaurantDemoClick}>
            Request a Demo for Restaurant
          </CTAButton>
          <CTAButton variant="secondary" onClick={handleRetailDemoClick}>
            Request a Demo for Retail
          </CTAButton>
        </div>
      </div>
    </div>
  );
};

export default CTASection;
